// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"271":"5369463d","595":"4518a5da"}[chunkId] + ".chunk.css";
};